import UserService from 'Services/user';

export default {
	props: {
		parent: {
			value: Object,
			default: undefined
		},
		defaultValues: {
			value: Object,
			default: undefined
		},
		wrapperClass: {
			value: String
		},
		enableVatCalculating: {
			value: Boolean
		},
		plan: {
			value: Object,
			default: undefined
		},
		enableHiddenValidation: {
			value: Boolean,
			default: false
		},
		tab: {
			value: Object,
			default: undefined
		}
	},
	created() {
		if (this.parent === undefined) {
			this.parent = this.$parent;
		}
		if (this.tab !== undefined) {
			this.customertabs = this.tab;
		}
		if (this.defaultValues !== undefined) {
			this.credential = this.defaultValues;
			if (this.tab === undefined && this.credential.company) {
				this.customertabs.state = 'business';
			}
		}
		if (this.defaultValues !== undefined && this.defaultValues.countrycode !== '' && this.enableVatCalculating) {
			this.calculateVat();
		}
		if (this.plan !== undefined) {
			if (this.plan.monthlyPrice) {
				this.price = this.plan.monthlyPrice;
				this.period = 'Month';
			} else {
				this.price = this.plan.annualPrice;
				this.period = 'Year';
			}
		}
		this.setVatPrefix();

		this.parent.$on('getBillingInfo', () => {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit('billingPayload', this.getCredentials());
				}
			});
		});
		this.parent.$on('validateBilling', () => {
			this.hiddenValidate();
		});
	},
	mounted() {
		this.hiddenValidate();
	},
	data() {
		return {
			isVatLoading: false,
			price: 0,
			period: 'Month',
			customertabs: {
				state: 'individual'
			},
			credential: {
				countrycode: '',
				firstname: '',
				lastname: '',
				address: '',
				city: '',
				zip: '',
				company: '',
				vatnumber: ''
			},
			euVatPrefix: '',
			euVatLabels: {
				AT: 'AT',
				BE: 'BE',
				BG: 'BG',
				HR: 'HR',
				CY: 'CY',
				CZ: 'CZ',
				DK: 'DK',
				EE: 'EE',
				FI: 'FI',
				FR: 'FR',
				DE: 'DE',
				GR: 'EL',
				HU: 'HU',
				IE: 'IE',
				IT: 'IT',
				LV: 'LV',
				LT: 'LT',
				LU: 'LU',
				MT: 'MT',
				NL: 'NL',
				PL: 'PL',
				PT: 'PT',
				RO: 'RO',
				SK: 'SK',
				SI: 'SI',
				ES: 'ES',
				SE: 'SE',
				GB: 'GB'
			},
			countries: [
				{ value: `US`, name: `United States of America` },
				{ value: `CA`, name: `Canada` },
				{ value: `GB`, name: `United Kingdom` },
				{ value: `AU`, name: `Australia` },
				{ value: `NZ`, name: `New Zealand` },
				{ value: `ZA`, name: `South Africa` },
				{ value: `AF`, name: `Afghanistan` },
				{ value: `AL`, name: `Albania` },
				{ value: `DZ`, name: `Algeria` },
				{ value: `AS`, name: `American Samoa` },
				{ value: `AD`, name: `Andorra` },
				{ value: `AO`, name: `Angola` },
				{ value: `AI`, name: `Anguilla` },
				{ value: `AQ`, name: `Antarctica` },
				{ value: `AG`, name: `Antigua and Barbuda` },
				{ value: `AR`, name: `Argentina` },
				{ value: `AM`, name: `Armenia` },
				{ value: `AW`, name: `Aruba` },
				{ value: `AT`, name: `Austria` },
				{ value: `AZ`, name: `Azerbaijan` },
				{ value: `BS`, name: `Bahamas` },
				{ value: `BH`, name: `Bahrain` },
				{ value: `BD`, name: `Bangladesh` },
				{ value: `BB`, name: `Barbados` },
				{ value: `BY`, name: `Belarus` },
				{ value: `BE`, name: `Belgium` },
				{ value: `BZ`, name: `Belize` },
				{ value: `BJ`, name: `Benin` },
				{ value: `BM`, name: `Bermuda` },
				{ value: `BT`, name: `Bhutan` },
				{ value: `BO`, name: `Bolivia` },
				{ value: `BA`, name: `Bosnia and Herzegovina` },
				{ value: `BW`, name: `Botswana` },
				{ value: `BV`, name: `Bouvet Island` },
				{ value: `BR`, name: `Brazil` },
				{ value: `IO`, name: `British Indian Ocean Territory` },
				{ value: `BN`, name: `Brunei Darussalam` },
				{ value: `BG`, name: `Bulgaria` },
				{ value: `BF`, name: `Burkina Faso` },
				{ value: `BI`, name: `Burundi` },
				{ value: `KH`, name: `Cambodia` },
				{ value: `CM`, name: `Cameroon` },
				{ value: `CV`, name: `Cape Verde` },
				{ value: `KY`, name: `Cayman Islands` },
				{ value: `CF`, name: `Central African Republic` },
				{ value: `TD`, name: `Chad` },
				{ value: `CL`, name: `Chile` },
				{ value: `CN`, name: `China` },
				{ value: `CX`, name: `Christmas Island` },
				{ value: `CC`, name: `Cocos (Keeling) Islands` },
				{ value: `CO`, name: `Colombia` },
				{ value: `KM`, name: `Comoros` },
				{ value: `CG`, name: `Congo` },
				{ value: `CK`, name: `Cook Islands` },
				{ value: `CR`, name: `Costa Rica` },
				{ value: `HR`, name: `Croatia` },
				{ value: `CU`, name: `Cuba` },
				{ value: `CY`, name: `Cyprus` },
				{ value: `CZ`, name: `Czech Republic` },
				{ value: `CI`, name: `Côte d'Ivoire` },
				{ value: `DK`, name: `Denmark` },
				{ value: `DJ`, name: `Djibouti` },
				{ value: `DM`, name: `Dominica` },
				{ value: `DO`, name: `Dominican Republic` },
				{ value: `TP`, name: `East Timor` },
				{ value: `EC`, name: `Ecuador` },
				{ value: `EG`, name: `Egypt` },
				{ value: `SV`, name: `El Salvador` },
				{ value: `GQ`, name: `Equatorial Guinea` },
				{ value: `ER`, name: `Eritrea` },
				{ value: `EE`, name: `Estonia` },
				{ value: `ET`, name: `Ethiopia` },
				{ value: `FK`, name: `Falkland Islands (Malvinas)` },
				{ value: `FO`, name: `Faroe Islands` },
				{ value: `FJ`, name: `Fiji` },
				{ value: `FI`, name: `Finland` },
				{ value: `FR`, name: `France` },
				{ value: `FX`, name: `France, Metropolitan` },
				{ value: `GF`, name: `French Guiana` },
				{ value: `PF`, name: `French Polynesia` },
				{ value: `TF`, name: `French Southern Territories` },
				{ value: `GA`, name: `Gabon` },
				{ value: `GM`, name: `Gambia` },
				{ value: `GE`, name: `Georgia` },
				{ value: `DE`, name: `Germany` },
				{ value: `GH`, name: `Ghana` },
				{ value: `GI`, name: `Gibraltar` },
				{ value: `GR`, name: `Greece` },
				{ value: `GL`, name: `Greenland` },
				{ value: `GD`, name: `Grenada` },
				{ value: `GP`, name: `Guadeloupe` },
				{ value: `GU`, name: `Guam` },
				{ value: `GT`, name: `Guatemala` },
				{ value: `GN`, name: `Guinea` },
				{ value: `GW`, name: `Guinea-Bissau` },
				{ value: `GY`, name: `Guyana` },
				{ value: `HT`, name: `Haiti` },
				{ value: `HM`, name: `Heard Island and McDonald Islands` },
				{ value: `HN`, name: `Honduras` },
				{ value: `HK`, name: `Hong Kong` },
				{ value: `HU`, name: `Hungary` },
				{ value: `IS`, name: `Iceland` },
				{ value: `IN`, name: `India` },
				{ value: `ID`, name: `Indonesia` },
				{ value: `IR`, name: `Iran, Islamic Republic of` },
				{ value: `IQ`, name: `Iraq` },
				{ value: `IE`, name: `Ireland` },
				{ value: `IL`, name: `Israel` },
				{ value: `IT`, name: `Italy` },
				{ value: `JM`, name: `Jamaica` },
				{ value: `JP`, name: `Japan` },
				{ value: `JO`, name: `Jordan` },
				{ value: `KZ`, name: `Kazakhstan` },
				{ value: `KE`, name: `Kenya` },
				{ value: `KI`, name: `Kiribati` },
				{ value: `KP`, name: `Korea, Democratic People's Republic of` },
				{ value: `KR`, name: `Korea, Republic of` },
				{ value: `KW`, name: `Kuwait` },
				{ value: `KG`, name: `Kyrgyzstan` },
				{ value: `LA`, name: `Lao People's Democratic Republic` },
				{ value: `LV`, name: `Latvia` },
				{ value: `LB`, name: `Lebanon` },
				{ value: `LS`, name: `Lesotho` },
				{ value: `LR`, name: `Liberia` },
				{ value: `LY`, name: `Libya` },
				{ value: `LI`, name: `Liechtenstein` },
				{ value: `LT`, name: `Lithuania` },
				{ value: `LU`, name: `Luxembourg` },
				{ value: `MO`, name: `Macao` },
				{ value: `MK`, name: `Macedonia, Republic of` },
				{ value: `MG`, name: `Madagascar` },
				{ value: `MW`, name: `Malawi` },
				{ value: `MY`, name: `Malaysia` },
				{ value: `MV`, name: `Maldives` },
				{ value: `ML`, name: `Mali` },
				{ value: `MT`, name: `Malta` },
				{ value: `MH`, name: `Marshall Islands` },
				{ value: `MQ`, name: `Martinique` },
				{ value: `MR`, name: `Mauritania` },
				{ value: `MU`, name: `Mauritius` },
				{ value: `YT`, name: `Mayotte` },
				{ value: `MX`, name: `Mexico` },
				{ value: `FM`, name: `Micronesia, Federated States of` },
				{ value: `MD`, name: `Moldova, Republic of` },
				{ value: `MC`, name: `Monaco` },
				{ value: `MN`, name: `Mongolia` },
				{ value: `MS`, name: `Montserrat` },
				{ value: `MA`, name: `Morocco` },
				{ value: `MZ`, name: `Mozambique` },
				{ value: `MM`, name: `Myanmar` },
				{ value: `NA`, name: `Namibia` },
				{ value: `NR`, name: `Nauru` },
				{ value: `NP`, name: `Nepal` },
				{ value: `NL`, name: `Netherlands` },
				{ value: `AN`, name: `Netherlands Antilles` },
				{ value: `NC`, name: `New Caledonia` },
				{ value: `NI`, name: `Nicaragua` },
				{ value: `NE`, name: `Niger` },
				{ value: `NG`, name: `Nigeria` },
				{ value: `NU`, name: `Niue` },
				{ value: `NF`, name: `Norfolk Island` },
				{ value: `MP`, name: `Northern Mariana Islands` },
				{ value: `NO`, name: `Norway` },
				{ value: `OM`, name: `Oman` },
				{ value: `PK`, name: `Pakistan` },
				{ value: `PW`, name: `Palau` },
				{ value: `PA`, name: `Panama` },
				{ value: `PG`, name: `Papua New Guinea` },
				{ value: `PY`, name: `Paraguay` },
				{ value: `PE`, name: `Peru` },
				{ value: `PH`, name: `Philippines` },
				{ value: `PN`, name: `Pitcairn` },
				{ value: `PL`, name: `Poland` },
				{ value: `PT`, name: `Portugal` },
				{ value: `PR`, name: `Puerto Rico` },
				{ value: `QA`, name: `Qatar` },
				{ value: `RO`, name: `Romania` },
				{ value: `RU`, name: `Russian Federation` },
				{ value: `RW`, name: `Rwanda` },
				{ value: `RE`, name: `Réunion` },
				{ value: `SH`, name: `Saint Helena, Ascension and Tristan da Cunha` },
				{ value: `KN`, name: `Saint Kitts and Nevis` },
				{ value: `LC`, name: `Saint Lucia` },
				{ value: `PM`, name: `Saint Pierre and Miquelon` },
				{ value: `VC`, name: `Saint Vincent and the Grenadines` },
				{ value: `WS`, name: `Samoa` },
				{ value: `SM`, name: `San Marino` },
				{ value: `ST`, name: `Sao Tome and Principe` },
				{ value: `SA`, name: `Saudi Arabia` },
				{ value: `SN`, name: `Senegal` },
				{ value: `RS`, name: `Serbia` },
				{ value: `SC`, name: `Seychelles` },
				{ value: `SL`, name: `Sierra Leone` },
				{ value: `SG`, name: `Singapore` },
				{ value: `SK`, name: `Slovakia` },
				{ value: `SI`, name: `Slovenia` },
				{ value: `SB`, name: `Solomon Islands` },
				{ value: `SO`, name: `Somalia` },
				{ value: `GS`, name: `South Georgia and the South Sandwich Islands` },
				{ value: `ES`, name: `Spain` },
				{ value: `LK`, name: `Sri Lanka` },
				{ value: `SD`, name: `Sudan` },
				{ value: `SR`, name: `Suriname` },
				{ value: `SJ`, name: `Svalbard and Jan Mayen` },
				{ value: `SZ`, name: `Swaziland` },
				{ value: `SE`, name: `Sweden` },
				{ value: `CH`, name: `Switzerland` },
				{ value: `SY`, name: `Syrian Arab Republic` },
				{ value: `TW`, name: `Taiwan` },
				{ value: `TJ`, name: `Tajikistan` },
				{ value: `TZ`, name: `Tanzania, United Republic of` },
				{ value: `TH`, name: `Thailand` },
				{ value: `TG`, name: `Togo` },
				{ value: `TK`, name: `Tokelau` },
				{ value: `TO`, name: `Tonga` },
				{ value: `TT`, name: `Trinidad and Tobago` },
				{ value: `TN`, name: `Tunisia` },
				{ value: `TR`, name: `Turkey` },
				{ value: `TM`, name: `Turkmenistan` },
				{ value: `TC`, name: `Turks and Caicos Islands` },
				{ value: `TV`, name: `Tuvalu` },
				{ value: `UG`, name: `Uganda` },
				{ value: `UA`, name: `Ukraine` },
				{ value: `AE`, name: `United Arab Emirates` },
				{ value: `UM`, name: `United States Minor Outlying Islands` },
				{ value: `UY`, name: `Uruguay` },
				{ value: `UZ`, name: `Uzbekistan` },
				{ value: `VU`, name: `Vanuatu` },
				{ value: `VA`, name: `Vatican City State (Holy See)` },
				{ value: `VE`, name: `Venezuela` },
				{ value: `VN`, name: `Viet Nam` },
				{ value: `VI`, name: `Virgin Islands of the United States` },
				{ value: `VG`, name: `Virgin Islands, British` },
				{ value: `WF`, name: `Wallis and Futuna` },
				{ value: `EH`, name: `Western Sahara` },
				{ value: `YE`, name: `Yemen` },
				{ value: `ZR`, name: `Zaire, Republic of` },
				{ value: `ZM`, name: `Zambia` },
				{ value: `ZW`, name: `Zimbabwe` }
			]
		};
	},
	computed: {
		countryTouched() {
			return this.isTouched(this.fields.country);
		},
		firstnameTouched() {
			return this.isTouched(this.fields.firstname);
		},
		lastnameTouched() {
			return this.isTouched(this.fields.lastname);
		},
		addressTouched() {
			return this.isTouched(this.fields.address);
		},
		cityTouched() {
			return this.isTouched(this.fields.city);
		},
		zipTouched() {
			return this.isTouched(this.fields.zip);
		},
		companyTouched() {
			return this.isTouched(this.fields.company);
		},
		vatnumberTouched() {
			return this.isTouched(this.fields.vatnumber);
		}
	},
	methods: {
		calculateVat() {
			if (!this.enableVatCalculating) {
				return;
			}
			this.isVatLoading = true;
			if (this.credential.countrycode) {
				UserService.getVat(this.plan.name, this.getCredentials())
					.then(response => {
						this.plan.tax = response.data.tax;
						this.plan.taxPercent = response.data.tax_percent;
						this.plan.priceTotal = response.data.price_total;
					})
					.catch(error => {
						this.errors.add({
							field: 'apierror',
							msg: 'Unable to calculate tax'
						});
					})
					.finally(() => {
						this.isVatLoading = false;
					});
			} else {
				this.plan.tax = '0.00';
				this.plan.taxPercent = 0;
				this.plan.priceTotal = this.price;
				this.isVatLoading = false;
			}
		},
		getCredentials() {
			var currentCredential = {
				countrycode: this.credential.countrycode,
				firstname: this.credential.firstname,
				lastname: this.credential.lastname,
				address: this.credential.address,
				city: this.credential.city,
				zip: this.credential.zip,
				company: '',
				vatnumber: ''
			};
			if (this.customertabs.state === 'business') {
				currentCredential.company = this.credential.company;
				currentCredential.vatnumber = this.credential.vatnumber;
			}
			return currentCredential;
		},
		setVatPrefix() {
			if (this.euVatLabels[this.credential.countrycode]) {
				this.euVatPrefix = '   ' + this.euVatLabels[this.credential.countrycode] + '-';
			} else {
				this.euVatPrefix = '';
			}
		},
		isTouched(field) {
			if (!this.enableHiddenValidation) {
				return true;
			}
			if (field) {
				return field.touched;
			}
			return true;
		},
		hiddenValidate() {
			if (!this.enableHiddenValidation) {
				return;
			}
			this.$validator.validateAll().then(result => {
				this.$emit('inputBlur', result);
			});
		}
	}
};



// WEBPACK FOOTER //
// ./app/components/billing-fields/script.js